<template>
  <transition name="mobilenav">
    <div v-if="isExpanded" ref="mobilenav" v-touch:swipe.right="closeTab" class="m-nav" :class="{'is-active': isExpanded}" :style="{height: windowHeight ? windowHeight + 'px' : '0px'}">
      <div class="m-nav-content">
        <!-- <div class="m-nav-content-search">
          <swiftype-search-input />
        </div>
        <div class="m-nav-content-presearch" v-if="!this.$store.getters['common/getFilteredSearchResults'].length && this.$store.getters['common/getPresearch']" :style="{height: windowHeight ? windowHeight + 'px' : '0px'}">
          <span class="m-nav-content-presearch-diamond"></span>
          Exclusive villas, local knowledge, thoughtful service
          <div class="m-nav-content-close m-nav-content-presearch-close" @click.prevent="closeTab">
            Close search
          </div>
        </div> -->
        <div class="navbar-search-back" @click.prevent="closeTab">
          <font-awesome-icon icon="caret-left" aria-label="left arrow" />&nbsp;Back
        </div>

        <ul class="m-nav-content-links">
          <li v-for="(link, i) in links" :key="i" :class="{'m-nav-content-links-break': link.text === 'break'}">
            <app-link v-if="link.text!=='break'" :id="link.id" :class="link.class" :type="link.type">
              <div v-if="link.class ==='callback'" :class="link.class">
                <a href="https://bookings.thethinkingtraveller.com/portal-embed#/customer/callbacks" target="_blank">Book an initial call</a>
              </div>
              <div v-if="link.class ==='selectors'" :class="link.class">
                <div class="selectors">
                  <language-selector class="langSelector" />
                  <currency-selector class="currencySelector" />
                </div>
              </div>
              {{ link.text }}
            </app-link>
            <span v-if="link.class==='experiences-nav' || 'exquisite-nav'" :class="link.span" alt="Experiences logo" />
          </li>
          <li v-if="isLoggedIn">
            <app-link :id="this.$store.state.pages.dashboardPageId" type="page">
              My dashboard
            </app-link>
          </li>
          <li v-if="!isLoggedIn">
            <app-link :id="this.$store.state.pages.loginPageId" type="page">
              Login
            </app-link>
          </li>
          <li v-if="isLoggedIn">
            <a @click.prevent="logout">Log out</a>
          </li>
        </ul>

        <div class="navbar-drawer__close text-center" @click.prevent="closeTab">
          Close <span class="navbar-drawer__close--icon" />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import translateUrl from '../../mixins/translateUrl';
import closeTab from '../../mixins/closeTab';
import languageSelector from '../languageSelector.vue';
import currencySelector from '../CurrencySelector.vue';

export default {
  components: {
    languageSelector,
    currencySelector,
  },
  mixins: [translateUrl, closeTab],
  data() {
    return {
      isLandscape: false,
      links: [
        {
          text: 'Home',
          type: 'page',
          id: 5,
        },
        {
          text: 'Search for your perfect villa',
          type: 'page',
          id: 16,
        },
        // {
        //   text: 'Book now for 2022',
        //   type: 'page',
        //   id: 879,
        // },
        {
          class: 'callback',
        },
        {
          text: 'break',
        },
        {
          text: 'Language & currency',
          class: 'title',
        },
        {
          class: 'selectors',
        },
        {
          text: 'break',
        },
        {
          text: 'Think Exquisite',
          class: 'title exquisite-nav',
          type: 'page',
          id: 39,
          span: 'exquisite-logo',
        },
        {
          text: 'Our finest luxury villas',
          type: 'page',
          id: 39,
        },
        {
          text: 'break',
        },
        {
          text: 'Experiences',
          class: 'title experiences-nav',
          type: 'page',
          id: 40,
          // span: 'experiences-logo'
        },
        {
          text: 'Holiday-enriching activities',
          type: 'page',
          id: 40,
        },
        {
          text: 'break',
        },
        {
          text: 'Destinations',
          class: 'title',
        },
        {
          text: 'Sicily',
          type: 'page',
          id: 26,
        },
        {
          text: 'Puglia',
          type: 'page',
          id: 28,
        },
        {
          text: 'Tuscan Islands',
          type: 'page',
          id: 835,
        },
        {
          text: 'Greece',
          type: 'page',
          id: 1087,
        },
        {
          text: 'Corsica',
          type: 'page',
          id: 30,
        },
        // {
        //   text: 'Mallorca',
        //   type: 'page',
        //   id: 943,
        // },
        {
          text: 'break',
        },
        {
          text: 'Unique Experiences',
          class: 'title',
        },
        {
          text: 'Wellness holidays',
          type: 'blog',
          id: 85,
        },
        {
          text: 'Cookery retreat with C. Puglisi',
          type: 'page',
          id: 840,
        },
        {
          text: 'Cooking retreat with Michael Tusk',
          type: 'page',
          id: 1143,
        },
        {
          text: 'Experiences',
          type: 'page',
          id: 40,
        },
        {
          text: 'break',
        },
        {
          text: 'Unique Events',
          class: 'title',
        },
        // {
        //   text: 'Weddings',
        //   type: 'collection',
        //   id: 230,
        // },
        // {
        //   text: 'Special celebrations',
        //   type: 'collection',
        //   id: 549,
        // },
        {
          text: 'break',
        },
        {
          text: 'The Thinking Traveller',
          class: 'title',
        },
        {
          text: 'Travel Notes blog',
          type: 'page',
          id: 1049,
        },
        {
          text: 'About us',
          type: 'page',
          id: 47,
        },
        // {
        //   text: 'Meet the team',
        //   type: 'page',
        //   id: 68,
        // },
        {
          text: 'Why travel with us',
          type: 'page',
          id: 64,
        },
        {
          text: 'Client reviews',
          type: 'page',
          id: 96,
        },
        {
          text: 'How to book',
          type: 'page',
          id: 44,
        },
        {
          text: 'Make an enquiry',
          type: 'page',
          id: 43,
        },
        // {
        //  text: 'Request a brochure',
        //  type: 'page',
        //  id: 42,
        // },
        {
          text: 'Contact us',
          type: 'page',
          id: 46,
        },
        {
          text: 'Sustainability and us',
          type: 'page',
          id: 843,
        },
        {
          text: 'LGBTQ friendly holidays',
          type: 'page',
          id: 842,
        },
        {
          text: 'FAQ',
          type: 'page',
          id: 49,
        },
        {
          text: 'break',
        },
        {
          text: 'Secure Client Area',
          class: 'title',
        },
      ],
    };
  },
  computed: {
    isLoggedIn(e) {
      return this.$store.getters['users/loggedInUser'] || false;
    },
    isExpanded() {
      if (this.$store.getters['common/getCurrentSection'] === 'Menumobile') {
        return true;
      }
      return false;
    },
    windowHeight() {
      return window.innerHeight;
    },
    searchWidth() {
      return this.$store.getters['common/getSearchWidth'];
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('users/logOut');
    },
    langChange(event) {
      Localize.setLanguage(event.target.value);
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/settings/_config.scss";

  body {
    overflow: hidden;
  }

  #blurrer {
    transition: all 0.2s ease-in-out;
  }

  #blurrer.animate {
    transform: translateX(var(--menu-width-minus));
  }

  .mobilenav-enter-active, .mobilenav-leave-active {
    transition: all 0.2s ease-in-out;
  }
  .mobilenav-enter, .mobilenav-leave-to {
    transform: translateX(var(--menu-width-plus));
  }
  .mobilenav-enter-to, .mobilenav-leave {
    transform: translateX(0);
  }

  .m {
    &-nav {
      padding: 0.625rem;
      background: $offwhite;
      display: block;
      position: fixed;
      top: 0;
      right: 0;
      z-index: 100;
      overflow-x: hidden; /* Disable horizontal scroll */
      overflow-y: scroll;
      &-content {
        display: flex;
        flex-direction: column;
        &-links {
          margin: 0;
          display: flex;
          flex-direction: column;
          align-items: left;
          padding: 0 1em;
          &-break {
            width: 100%;
            height: 1px;
            background: $mortar;
            display: block;
            margin: 0.5rem 0 0.5rem 0;
          }
          li {
            a {
              color: $mortar;
              font-size: 1.125rem;
              font-weight: 500;
              font-family: $font-family-grotesk;
            }
          }
        }
      }
      &.is-active {
        height: 100% !important;
        width: 100%;
        z-index: 3002 !important;
      }
    }
  }

// @media screen and (orientation:landscape) {
//   .m {
//     &-nav {
//       &-content {
//         &-close {
//           margin: 1rem 0 0 0;
//         }
//         &-links {
//           overflow-y: scroll;
//           height: 200px;
//           &-break {
//             display: none;
//           }
//         }
//       }
//     }
//   }
// }

.title {
  color: $darkBlack !important;
  font-size: 1rem !important;
  line-height: 2rem !important;
  padding: 0 0 5px 0 !important;
  margin: 0 0 10px 0 !important;
  font-family: $font-family-editorial!important;
  font-weight: 700 !important;
  background-repeat: no-repeat;
  width: 34px;
  background-size: contain;
  background-position: left;
}

.navbar-search-back {
  height: 30px;
  color: $echo-blue;
  font-weight: 500;
  display: flex;
  align-items: center;
  &-icon {
    width: 7px;
    height: 9px;
    // margin: 9px 6px 6px 0;
    background-color: $echo-blue;
    display: inline;

  }
}

</style>

<style lang="scss" scoped>
@import "../../assets/styles/settings/_config.scss";

.exquisite-logo {
  background-image: url(../../assets/img/src/icons/t-exquisite-logo.svg);
    width: 34px;
    height: 35px;
    display: inline-block;
    margin: 0 14px 0 0;
    position: relative;
    top: 25px;
    left: 50px;
}

// .experiences-logo {
//   background-image: url(../../assets/img/src/logos/think-experiences-logo.svg);
//   width: 47px;
//   height: 24px;
//   display: inline-block;
//   margin: 0 5px 0 0;
//   position: relative;
//   top: 10px;
// }

.currencySelector::v-deep {
  .currency-selected {
    font-weight: 500;
    color: $darkBlack;
  }
  .currency-content--light {
    margin: 5px 0 0 0;
  }
}

.langSelector::v-deep {
    color: $darkBlack;
}

   .selectors {
      height: 25px;
      display: flex;
      align-items: center;
    }
    .currencySelector {
      margin-left: 30px;
    }
</style>
